import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const names = ['Carlos', 'María', 'Juan', 'Ana', 'Pedro', 'Laura', 'Diego', 'Sofía', 'Miguel', 'Valentina'];
const cities = ['Buenos Aires, Argentina', 'Ciudad de México, México', 'Madrid, España', 'Lima, Perú', 'Bogotá, Colombia', 'Santiago, Chile', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Barcelona, España', 'Medellín, Colombia'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Random interval between 15 and 30 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * (30000 - 15000 + 1) + 15000));
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-173">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white border border-[#E8D5C4] rounded-xl p-4 shadow-2xl flex items-center gap-4 max-w-sm" data-id="element-174">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-175">
            <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-176" />
          </div>
          <div data-id="element-177">
            <p className="text-sm text-[#6B5344]" data-id="element-178">
              <strong className="text-[#3D2B1F]" data-id="element-179">{currentBuyer.name}</strong> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs text-[#D4850A] font-medium mt-1" data-id="element-180">
              Acaba de comprar este producto
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}